(function () {
  'use strict';

  var API_BASE = window.RENNEWAY_API_BASE || '';
  var ACCOUNT_URL = '/pages/account';

  function isTR() {
    var l = (window.RENNEWAY_I18N && window.RENNEWAY_I18N['common.lang']) || document.documentElement.lang || 'en';
    return String(l).toLowerCase().indexOf('tr') === 0;
  }

  var TEXT = {
    addToCart: { tr: 'Sepete ekle', en: 'Add to cart' },
    added:{ tr: 'Sepete eklendi', en: 'Added to cart' },
    updated: { tr: 'Sepetteki miktar güncellendi', en: 'Cart quantity updated' },
    goCart: { tr: 'Sepete git', en: 'View cart' },
    cartTitle: { tr: 'Sepetim', en: 'My cart' },
    cartSub: { tr: 'Farklı tedarikçilerin ürünlerini tek siparişte tamamlayın.', en: 'Complete products from different suppliers in a single checkout.' },
    emptyTitle: { tr: 'Sepetiniz boş', en: 'Your cart is empty' },
    emptyDesc: { tr: 'Ürün sayfasında tedarikçi teklifini seçip "Sepete ekle" ile ekleyebilirsiniz.', en: 'Choose a supplier offer on a product page and tap "Add to cart".' },
    explore: { tr: 'Ürünlere göz at', en: 'Explore products' },
    notApproved: { tr: 'Sepet, onaylı firma hesaplarına açıktır. Hesabınız onaylandığında burada sipariş verebilirsiniz.', en: 'The cart is available to approved company accounts. Once your account is approved you can order here.' },
    loading: { tr: 'Yükleniyor', en: 'Loading' },
    loadError: { tr: 'Sepet yüklenemedi. Sayfayı yenileyin.', en: 'Could not load the cart. Please refresh the page.' },
    supplier: { tr: 'Tedarikçi', en: 'Supplier' },
    acceptsBank: { tr: 'Havale kabul ediyor', en: 'Accepts bank transfer' },
    cardOnly: { tr: 'Yalnızca kart', en: 'Card only' },
    bankPending: { tr: 'Havale bilgisi bekleniyor', en: 'Bank details pending' },
    subtotal: { tr: 'Ara toplam', en: 'Subtotal' },
    total: { tr: 'Toplam', en: 'Total' },
    productsTotal: { tr: 'Ürün toplamı', en: 'Products total' },
    serviceFee: { tr: 'Hizmet bedeli (kartla ödeme, %{pct})', en: 'Service fee (card payment, {pct}%)' },
    qty: { tr: 'Miktar (kg)', en: 'Quantity (kg)' },
    minHint: { tr: 'Min {min} kg · Stok {stock} kg', en: 'Min {min} kg · Stock {stock} kg' },
    remove: { tr: 'Kaldır', en: 'Remove' },
    number: { tr: 'Numara', en: 'Number' },
    color: { tr: 'Renk', en: 'Color' },
    priceChanged: { tr: 'Fiyat güncellendi: ${old} → ${now} /kg', en: 'Price updated: ${old} → ${now} /kg' },
    invalidTitle: { tr: 'Sipariş edilemeyen ürünler', en: 'Items that cannot be ordered' },
    invalidHint: { tr: 'Bu ürünleri kaldırın ya da miktarı düzeltin; ödeme için sepette geçersiz ürün kalmamalı.', en: 'Remove these items or fix the quantity; the cart must not contain invalid items to check out.' },
    tlNote: { tr: 'TL tutar, siparişi tamamladığınız anda TCMB kuruyla hesaplanır.', en: 'The TRY amount is calculated with the Central Bank rate when you place the order.' },
    shipping: { tr: 'Teslimat', en: 'Delivery' },
    shipAssist: { tr: 'Nakliyeyi tedarikçi ayarlasın', en: 'Supplier arranges transport' },
    shipOwn: { tr: 'Kendi kargo firmama teslim edilsin', en: 'Hand over to my own carrier' },
    carrierName: { tr: 'Kargo firması', en: 'Carrier name' },
    carrierAddress: { tr: 'Kargo teslim adresi', en: 'Carrier drop-off address' },
    carrierPhone: { tr: 'Kargo telefonu (opsiyonel)', en: 'Carrier phone (optional)' },
    carrierCode: { tr: 'Müşteri/cari kodu (opsiyonel)', en: 'Customer code (optional)' },
    address: { tr: 'Fatura / teslim adresi', en: 'Billing / delivery address' },
    addressLine: { tr: 'Adres', en: 'Address' },
    city: { tr: 'Şehir', en: 'City' },
    country: { tr: 'Ülke', en: 'Country' },
    notes: { tr: 'Sipariş notu (opsiyonel)', en: 'Order note (optional)' },
    payment: { tr: 'Ödeme yöntemi', en: 'Payment method' },
    payCard: { tr: 'Kredi / banka kartı', en: 'Credit / debit card' },
    payCardHint: { tr: 'Tek ödeme; Renneway üzerinden tahsil edilir. Ürün tutarına ek %10 hizmet bedeli uygulanır.', en: 'One payment, collected by Renneway. A 10% service fee is added to the product total.' },
    payBank: { tr: 'Havale / EFT', en: 'Bank transfer' },
    payBankHint: { tr: 'Her tedarikçiye kendi IBAN\'ına ayrı ödeme yaparsınız. Komisyon yok.', en: 'You pay each supplier separately to their own IBAN. No commission.' },
    payBankOff: { tr: 'Şu tedarikçiler havale kabul etmiyor: {names}. Kartla ödeyebilir ya da bu ürünleri kaldırabilirsiniz.', en: 'These suppliers do not accept bank transfer: {names}. Pay by card or remove their items.' },
    bankMissing: { tr: 'Şu tedarikçiler henüz havale bilgilerini eklemedi: {names}. Siparişi tamamlamak için bu ürünleri sepetten kaldırın.', en: 'These suppliers have not added bank transfer details yet: {names}. Remove their items to complete your order.' },
    placeOrder: { tr: 'Siparişi tamamla', en: 'Place order' },
    toPayment: { tr: 'Ödemeye geç', en: 'Continue to payment' },
    working: { tr: 'İşleniyor…', en: 'Processing…' },
    redirecting: { tr: 'Ödeme sayfasına yönlendiriliyorsunuz…', en: 'Redirecting to payment…' },
    netErr: { tr: 'Bağlantı hatası, tekrar deneyin.', en: 'Network error, please try again.' },
    required: { tr: 'Bu alan zorunlu', en: 'This field is required' },
    bankDoneTitle: { tr: 'Siparişiniz oluşturuldu', en: 'Your order has been placed' },
    bankDoneSub: { tr: 'Her tedarikçiye aşağıdaki tutarı kendi hesabına gönderin ve açıklamaya referansı yazın. Havaleyi yaptıktan sonra ilgili tedarikçi için "Havaleyi yaptım"a basın.', en: 'Send each supplier the amount below to their own account and write the reference in the description. After the transfer, tap "I made the transfer" for that supplier.' },
    bank: { tr: 'Banka', en: 'Bank' },
    holder: { tr: 'Alıcı', en: 'Account holder' },
    amount: { tr: 'Tutar', en: 'Amount' },
    reference: { tr: 'Açıklama / referans', en: 'Description / reference' },
    orders: { tr: 'Siparişler', en: 'Orders' },
    copy: { tr: 'Kopyala', en: 'Copy' },
    copied: { tr: 'Kopyalandı', en: 'Copied' },
    declare: { tr: 'Havaleyi yaptım', en: 'I made the transfer' },
    declareConfirm: { tr: '{name} için havaleyi yaptığınızı onaylıyor musunuz?', en: 'Confirm that you made the transfer to {name}?' },
    declared: { tr: 'Havale bildirildi — tedarikçi onayı bekleniyor', en: 'Transfer declared — waiting for supplier confirmation' },
    goOrders: { tr: 'Siparişlerime git', en: 'Go to my orders' },
    pendingTitle: { tr: 'Bekleyen havaleler', en: 'Pending bank transfers' },
    pendingSub: { tr: 'Sepet siparişleriniz için tedarikçilere yapılacak ödemeler.', en: 'Payments to suppliers for your cart orders.' },
    paidBanner: { tr: 'Ödemeniz alındı. Siparişleriniz tedarikçilere iletildi.', en: 'Payment received. Your orders have been sent to the suppliers.' },
    failedBanner: { tr: 'Ödeme tamamlanamadı. Sepetiniz duruyor; tekrar deneyebilirsiniz.', en: 'Payment could not be completed. Your cart is kept; you can try again.' },
    cartBtn: { tr: 'Sepet', en: 'Cart' },
    e_shipping_required: { tr: 'Teslimat seçeneği seçin.', en: 'Please choose a delivery option.' },
    e_carrier_name_required: { tr: 'Kargo firması adı zorunlu.', en: 'Carrier name is required.' },
    e_carrier_address_required: { tr: 'Kargo teslim adresi zorunlu.', en: 'Carrier address is required.' },
    e_invalid_kg: { tr: 'Geçerli bir miktar girin.', en: 'Enter a valid quantity.' },
    e_offer_unavailable: { tr: 'Bu teklif artık geçerli değil.', en: 'This offer is no longer available.' },
    e_origin_unavailable: { tr: 'Seçilen menşe artık sunulmuyor.', en: 'The selected origin is no longer offered.' },
    e_out_of_stock: { tr: 'Bu menşe için stok kalmadı.', en: 'Out of stock for this origin.' },
    e_min_order: { tr: 'Minimum sipariş {min} kg.', en: 'Minimum order is {min} kg.' },
    e_stock_limit: { tr: 'Stokta yalnızca {stock} kg var.', en: 'Only {stock} kg in stock.' },
    e_cert_unavailable: { tr: 'Seçilen sertifika bu teklifte artık yok.', en: 'The selected certificate is no longer available in this offer.' },
    e_price_changed: { tr: 'Fiyatlar güncellendi. Lütfen yeni toplamı kontrol edin.', en: 'Prices were updated. Please review the new total.' },
    e_cart_empty: { tr: 'Sepetiniz boş.', en: 'Your cart is empty.' },
    e_cart_invalid: { tr: 'Sepetteki bazı ürünler artık sipariş edilemiyor. Lütfen sepeti kontrol edin.', en: 'Some items can no longer be ordered. Please review your cart.' },
    e_bank_not_available: { tr: 'Şu tedarikçiler havale kabul etmiyor: {names}. Kartla ödeyebilir ya da bu ürünleri kaldırabilirsiniz.', en: 'These suppliers do not accept bank transfer: {names}. Pay by card or remove their items.' },
    e_cart_full: { tr: 'Sepette en fazla 50 ürün olabilir.', en: 'The cart can hold at most 50 items.' },
    e_fx_unavailable: { tr: 'Döviz kuru alınamadı, birkaç dakika sonra tekrar deneyin.', en: 'Exchange rate unavailable, please try again in a few minutes.' },
    supplierCart: { tr: 'Tedarikçi hesabıyla sepet ve sipariş kullanılamaz.', en: 'Cart and ordering are not available for supplier accounts.' },
    e_supplier_account: { tr: 'Tedarikçi hesabıyla sipariş verilemez.', en: 'Orders cannot be placed from a supplier account.' },
    e_approval_required: { tr: 'Bu işlem onaylı firma hesapları içindir.', en: 'This action is available to approved company accounts.' }
  };

  function errText(data, fallback) {
    data = data || {};
    var code = data.code || data.errorCode;
    if (code && TEXT['e_' + code]) return t('e_' + code, data.params || data.errorParams);
    return data.error || fallback || t('netErr');
  }
  function t(k, vars) {
    var s = (TEXT[k] || {})[isTR() ? 'tr' : 'en'] || k;
    if (vars) s = s.replace(/\{(\w+)\}/g, function (_, v) { return vars[v] != null ? vars[v] : ''; });
    return s;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function usd(n) {
    return '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function tl(n) {
    return Number(n || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }
  function token() { return window.rnwToken ? window.rnwToken.get() : ''; }

  function api(path, opts) {
    opts = opts || {};
    var headers = { 'Accept': 'application/json' };
    if (opts.body !== undefined) headers['Content-Type'] = 'application/json';
    var tok = token();
    if (tok) headers['Authorization'] = 'Bearer ' + tok;
    return fetch(API_BASE + '/api/public' + path, {
      method: opts.method || 'GET',
      headers: headers,
      body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        return { ok: r.ok, status: r.status, data: data };
      });
    });
  }

  // ---- Sepet adedi: yuzen buton + hesap sekmesi rozeti ----

  var lastCount = 0;

  function ensureFab() {
    var fab = document.querySelector('[data-rnw-cart-fab]');
    if (fab) return fab;
    if (document.getElementById('rnw-account')) return null;
    fab = document.createElement('a');
    fab.className = 'rnw-cart-fab';
    fab.setAttribute('data-rnw-cart-fab', '');
    fab.href = ACCOUNT_URL + '#cart';
    fab.hidden = true;
    fab.innerHTML =
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
      '<span class="rnw-cart-fab__label">' + esc(t('cartBtn')) + '</span>' +
      '<span class="rnw-cart-fab__count" data-rnw-cart-count>0</span>';
    document.body.appendChild(fab);
    return fab;
  }

  function setCount(n) {
    lastCount = n || 0;
    var fab = ensureFab();
    if (fab) fab.hidden = lastCount === 0;
    document.querySelectorAll('[data-rnw-cart-count]').forEach(function (el) { el.textContent = lastCount; });
    document.querySelectorAll('[data-rnw-tab-badge="cart"]').forEach(function (el) {
      el.textContent = lastCount;
      el.hidden = lastCount === 0;
    });
  }

  function refreshBadge() {
    if (!token()) { setCount(0); return Promise.resolve(0); }
    return api('/cart/count').then(function (res) {
      var n = res.ok ? (res.data.count || 0) : 0;
      setCount(n);
      return n;
    }).catch(function () { return lastCount; });
  }

  // ---- Bildirim ----

  var toastTimer = null;
  function toast(msg, withLink, isError) {
    var el = document.querySelector('.rnw-cart-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'rnw-cart-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.classList.toggle('is-error', !!isError);
    el.innerHTML = '<span>' + esc(msg) + '</span>' +
      (withLink ? '<a href="' + ACCOUNT_URL + '#cart">' + esc(t('goCart')) + ' →</a>' : '');
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 5000);
  }

  function add(payload) {
    return api('/cart/items', { method: 'POST', body: payload }).then(function (res) {
      if (res.ok) {
        setCount(res.data.count);
        toast(res.data.updated ? t('updated') : t('added'), true);
      } else {
        toast(errText(res.data), false, true);
      }
      return res;
    }).catch(function () {
      toast(t('netErr'), false, true);
      return { ok: false, data: { error: t('netErr') } };
    });
  }

  // ---- Sepet gorunumu (hesap sayfasi #cart) ----

  var view = { root: null, customer: null, cart: null, error: '' };

  function mount(root, opts) {
    view.root = root;
    view.customer = (opts && opts.customer) || null;
    if (!root) return;
    if (view.customer && view.customer.priceAccess && view.customer.priceAccess !== 'approved') {
      root.innerHTML = head() + '<div class="rnw-cart-note">' + esc(t(view.customer.priceAccess === 'supplier' ? 'supplierCart' : 'notApproved')) + '</div>';
      return;
    }
    root.innerHTML = head() + '<div class="rnw-acc-loading"><div class="rnw-acc-loading__spin"></div><div>' + esc(t('loading')) + '</div></div>';
    api('/cart').then(function (res) {
      if (!res.ok) {
        root.innerHTML = head() + '<div class="rnw-cart-note is-error">' + esc(errText(res.data, t('loadError'))) + '</div>';
        return;
      }
      view.cart = res.data;
      view.error = '';
      render();
    }).catch(function () {
      root.innerHTML = head() + '<div class="rnw-cart-note is-error">' + esc(t('loadError')) + '</div>';
    });
  }

  function head() {
    return '<div class="rnw-acc-section-head"><div>' +
      '<h2 class="rnw-acc-h2">' + esc(t('cartTitle')) + '</h2>' +
      '<p class="rnw-acc-h2-sub">' + esc(t('cartSub')) + '</p>' +
      '</div></div>';
  }

  function lineErr(it) {
    return errText({ errorCode: it.errorCode, errorParams: it.errorParams, error: it.error });
  }

  function lineHtml(it) {
    if (!it.valid && !it.product) {
      return '<div class="rnw-cart-line is-invalid" data-line="' + esc(it.id) + '">' +
        '<div class="rnw-cart-line__body"><div class="rnw-cart-line__err">' + esc(lineErr(it)) + '</div></div>' +
        '<button type="button" class="rnw-cart-line__remove" data-remove="' + esc(it.id) + '">' + esc(t('remove')) + '</button>' +
      '</div>';
    }
    var p = it.product || {};
    var origin = it.origin ? (it.origin.flagEmoji ? it.origin.flagEmoji + ' ' : '') + (isTR() ? (it.origin.nameTR || it.origin.name) : (it.origin.nameEN || it.origin.name)) : '';
    var certs = it.pricing && it.pricing.certificates && it.pricing.certificates.length
      ? '<div class="rnw-cart-line__certs">' + it.pricing.certificates.map(function (c) {
          return '<span>' + esc(c.name) + ' %' + esc(c.percent) + ' · ' + usd(c.amount) + '</span>';
        }).join('') + '</div>'
      : '';
    var changed = it.priceChanged
      ? '<div class="rnw-cart-line__changed">' + esc(t('priceChanged', { old: Number(it.previousPricePerKg).toFixed(2), now: Number(it.pricing.pricePerKg).toFixed(2) })) + '</div>'
      : '';
    var err = it.valid ? '' : '<div class="rnw-cart-line__err">' + esc(lineErr(it)) + '</div>';
    var hint = it.minOrderKg != null ? t('minHint', { min: it.minOrderKg, stock: it.stockKg }) : '';
    return '<div class="rnw-cart-line' + (it.valid ? '' : ' is-invalid') + '" data-line="' + esc(it.id) + '">' +
      (p.image ? '<img class="rnw-cart-line__img" src="' + esc(p.image) + '" alt="" loading="lazy">' : '<div class="rnw-cart-line__img"></div>') +
      '<div class="rnw-cart-line__body">' +
        '<a class="rnw-cart-line__title" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
        '<div class="rnw-cart-line__meta">' +
          '<span>' + esc(t('number')) + ': ' + esc(p.number || '—') + '</span>' +
          '<span>' + esc(t('color')) + ': ' + esc(p.color || '—') + '</span>' +
          (origin ? '<span>' + esc(origin) + '</span>' : '') +
        '</div>' +
        certs + changed + err +
      '</div>' +
      '<div class="rnw-cart-line__qty">' +
        '<label><span>' + esc(t('qty')) + '</span>' +
        '<input type="number" min="1" step="1" inputmode="numeric" value="' + esc(it.kg) + '" data-qty="' + esc(it.id) + '"></label>' +
        (hint ? '<small>' + esc(hint) + '</small>' : '') +
      '</div>' +
      '<div class="rnw-cart-line__price">' +
        (it.pricing ? '<small>' + esc(it.kg) + ' kg × ' + usd(it.pricing.pricePerKg) + '</small><strong>' + usd(it.pricing.total) + '</strong>' : '') +
        '<button type="button" class="rnw-cart-line__remove" data-remove="' + esc(it.id) + '">' + esc(t('remove')) + '</button>' +
      '</div>' +
    '</div>';
  }

  function render() {
    var root = view.root, cart = view.cart;
    if (!root || !cart) return;
    setCount(cart.count);
    if (!cart.count) {
      root.innerHTML = head() +
        '<div class="rnw-acc-empty">' +
          '<div class="rnw-acc-empty__title">' + esc(t('emptyTitle')) + '</div>' +
          '<div class="rnw-acc-empty__desc">' + esc(t('emptyDesc')) + '</div>' +
          '<a href="/collections/all" class="rnw-acc-btn rnw-acc-btn--sm">' + esc(t('explore')) + '</a>' +
        '</div>';
      return;
    }
    var byId = {};
    cart.items.forEach(function (it) { byId[it.id] = it; });

    var groupsHtml = cart.groups.map(function (g) {
      return '<section class="rnw-cart-group">' +
        '<header class="rnw-cart-group__head">' +
          '<div><span class="rnw-cart-group__label">' + esc(t('supplier')) + '</span>' +
          '<strong class="rnw-cart-group__name">' + esc(g.supplier.name) + '</strong></div>' +
          '<span class="rnw-cart-tag' + (g.supplier.acceptsBankTransfer ? ' is-bank' : '') + '">' +
            esc(g.supplier.acceptsBankTransfer ? t('acceptsBank') : (cardEnabled(cart) ? t('cardOnly') : t('bankPending'))) + '</span>' +
        '</header>' +
        g.itemIds.map(function (id) { return lineHtml(byId[id]); }).join('') +
        '<footer class="rnw-cart-group__foot"><span>' + esc(t('subtotal')) + '</span><strong>' + usd(g.totalUSD) + '</strong></footer>' +
      '</section>';
    }).join('');

    var invalid = cart.items.filter(function (it) { return !it.valid; });
    var invalidHtml = invalid.length
      ? '<section class="rnw-cart-group is-invalid">' +
          '<header class="rnw-cart-group__head"><div><strong class="rnw-cart-group__name">' + esc(t('invalidTitle')) + '</strong>' +
          '<div class="rnw-cart-group__hint">' + esc(t('invalidHint')) + '</div></div></header>' +
          invalid.map(lineHtml).join('') +
        '</section>'
      : '';

    root.innerHTML = head() +
      '<div class="rnw-cart">' +
        '<div class="rnw-cart__lines">' + invalidHtml + groupsHtml + '</div>' +
        '<aside class="rnw-cart__summary">' + summaryHtml(cart) + '</aside>' +
      '</div>';
    bindCart();
  }

  // Kart secenegi yalnizca API izin veriyorsa (cart.paymentMethods) gosterilir
  function cardEnabled(cart) {
    return !!(cart && Array.isArray(cart.paymentMethods) && cart.paymentMethods.indexOf('iyzico') !== -1);
  }

  function summaryHtml(cart) {
    var c = view.customer || {};
    var addrs = c.addresses || [];
    var noBank = cart.groups.filter(function (g) { return !g.supplier.acceptsBankTransfer; })
      .map(function (g) { return g.supplier.name; });
    var addrHtml = addrs.length
      ? '<select name="addressId" class="rnw-cart-input">' + addrs.map(function (a) {
          var id = a._id || a.id;
          var label = (a.label ? a.label + ' — ' : '') + [a.addressLine, a.city, a.country].filter(Boolean).join(', ');
          return '<option value="' + esc(id) + '"' + (a.isDefault ? ' selected' : '') + '>' + esc(label) + '</option>';
        }).join('') + '</select>'
      : '<input class="rnw-cart-input" name="addressLine" placeholder="' + esc(t('addressLine')) + '" value="' + esc(c.addressLine || '') + '" required>' +
        '<div class="rnw-cart-row">' +
          '<input class="rnw-cart-input" name="city" placeholder="' + esc(t('city')) + '" value="' + esc(c.city || '') + '">' +
          '<input class="rnw-cart-input" name="country" placeholder="' + esc(t('country')) + '" value="' + esc(c.country || '') + '">' +
        '</div>';

    var cardOn = cardEnabled(cart);
    var bankOk = noBank.length === 0;
    var useCard = cardOn && !bankOk;
    var feeRate = cardOn ? Number(cart.cardServiceFeeRate || 0) : 0;
    var feeUSD = Math.round(cart.totalUSD * feeRate * 100) / 100;
    var shownTotal = useCard ? cart.totalUSD + feeUSD : cart.totalUSD;
    return '<div class="rnw-cart-row-line"><span>' + esc(t('productsTotal')) + '</span><span>' + usd(cart.totalUSD) + '</span></div>' +
      (cardOn ? '<div class="rnw-cart-row-line" data-fee-row' + (useCard ? '' : ' hidden') + '><span>' + esc(t('serviceFee', { pct: Math.round(feeRate * 100) })) + '</span><span>' + usd(feeUSD) + '</span></div>' : '') +
      '<div class="rnw-cart-total"><span>' + esc(t('total')) + '</span><strong data-grand-total data-card="' + usd(cart.totalUSD + feeUSD) + '" data-bank="' + usd(cart.totalUSD) + '">' + usd(shownTotal) + '</strong></div>' +
      '<p class="rnw-cart-small">' + esc(t('tlNote')) + '</p>' +
      '<form class="rnw-cart-form" data-rnw-checkout novalidate>' +
        '<fieldset><legend>' + esc(t('shipping')) + '</legend>' +
          '<label class="rnw-cart-radio"><input type="radio" name="shippingPreference" value="need_assistance" checked> ' + esc(t('shipAssist')) + '</label>' +
          '<label class="rnw-cart-radio"><input type="radio" name="shippingPreference" value="own_carrier"> ' + esc(t('shipOwn')) + '</label>' +
          '<div class="rnw-cart-carrier" data-carrier hidden>' +
            '<input class="rnw-cart-input" name="carrierName" placeholder="' + esc(t('carrierName')) + '">' +
            '<input class="rnw-cart-input" name="carrierAddress" placeholder="' + esc(t('carrierAddress')) + '">' +
            '<div class="rnw-cart-row">' +
              '<input class="rnw-cart-input" name="carrierPhone" placeholder="' + esc(t('carrierPhone')) + '">' +
              '<input class="rnw-cart-input" name="customerCode" placeholder="' + esc(t('carrierCode')) + '">' +
            '</div>' +
          '</div>' +
        '</fieldset>' +
        '<fieldset><legend>' + esc(t('address')) + '</legend>' + addrHtml +
          '<textarea class="rnw-cart-input" name="notes" rows="2" maxlength="1000" placeholder="' + esc(t('notes')) + '"></textarea>' +
        '</fieldset>' +
        '<fieldset><legend>' + esc(t('payment')) + '</legend>' +
          (cardOn
            ? '<label class="rnw-cart-pay"><input type="radio" name="paymentMethod" value="iyzico"' + (useCard ? ' checked' : '') + '>' +
              '<span><strong>' + esc(t('payCard')) + '</strong><small>' + esc(t('payCardHint')) + '</small></span></label>'
            : '') +
          '<label class="rnw-cart-pay' + (bankOk ? '' : ' is-disabled') + '"><input type="radio" name="paymentMethod" value="bank_transfer"' + (bankOk ? ' checked' : ' disabled') + '>' +
            '<span><strong>' + esc(t('payBank')) + '</strong><small>' + esc(bankOk ? t('payBankHint') : t(cardOn ? 'payBankOff' : 'bankMissing', { names: noBank.join(', ') })) + '</small></span></label>' +
        '</fieldset>' +
        '<div class="rnw-cart-note is-error" data-checkout-err' + (view.error ? '' : ' hidden') + '>' + esc(view.error) + '</div>' +
        '<button type="submit" class="rnw-acc-btn rnw-acc-btn--primary rnw-acc-btn--full" data-checkout-btn' + (cart.hasInvalid || (!bankOk && !cardOn) ? ' disabled' : '') + '>' + esc(useCard ? t('toPayment') : t('placeOrder')) + '</button>' +
      '</form>';
  }

  function bindCart() {
    var root = view.root;
    root.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        api('/cart/items/' + btn.getAttribute('data-remove'), { method: 'DELETE' }).then(function (res) {
          if (res.ok) { view.cart = res.data; view.error = ''; render(); }
          else { btn.disabled = false; toast(errText(res.data), false, true); }
        });
      });
    });
    root.querySelectorAll('[data-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var kg = Number(input.value);
        if (!kg || kg <= 0) return;
        input.disabled = true;
        api('/cart/items/' + input.getAttribute('data-qty'), { method: 'PATCH', body: { kg: kg } }).then(function (res) {
          if (res.ok) { view.cart = res.data; view.error = ''; render(); }
          else {
            input.disabled = false;
            var line = input.closest('.rnw-cart-line');
            var box = line && line.querySelector('.rnw-cart-line__body');
            if (box) {
              var err = box.querySelector('.rnw-cart-line__err') || document.createElement('div');
              err.className = 'rnw-cart-line__err';
              err.textContent = errText(res.data);
              box.appendChild(err);
            }
          }
        });
      });
    });

    var form = root.querySelector('[data-rnw-checkout]');
    if (!form) return;
    var carrier = form.querySelector('[data-carrier]');
    var btn = form.querySelector('[data-checkout-btn]');
    function syncForm() {
      var ship = form.querySelector('input[name="shippingPreference"]:checked');
      carrier.hidden = !ship || ship.value !== 'own_carrier';
      var pay = form.querySelector('input[name="paymentMethod"]:checked');
      var isBank = !pay || pay.value === 'bank_transfer';
      btn.textContent = isBank ? t('placeOrder') : t('toPayment');
      var feeRow = root.querySelector('[data-fee-row]');
      if (feeRow) feeRow.hidden = isBank;
      var grand = root.querySelector('[data-grand-total]');
      if (grand) grand.textContent = grand.getAttribute(isBank ? 'data-bank' : 'data-card');
    }
    form.querySelectorAll('input[type="radio"]').forEach(function (r) { r.addEventListener('change', syncForm); });
    syncForm();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitCheckout(form);
    });
  }

  function fieldVal(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? String(el.value || '').trim() : '';
  }

  function submitCheckout(form) {
    var errEl = form.querySelector('[data-checkout-err]');
    var btn = form.querySelector('[data-checkout-btn]');
    var pay = form.querySelector('input[name="paymentMethod"]:checked');
    var ship = form.querySelector('input[name="shippingPreference"]:checked');
    var paymentMethod = pay ? pay.value : 'bank_transfer';
    var shipping = { preference: ship ? ship.value : 'need_assistance' };
    errEl.hidden = true;
    form.querySelectorAll('.is-missing').forEach(function (el) { el.classList.remove('is-missing'); });

    var missing = [];
    if (shipping.preference === 'own_carrier') {
      shipping.carrierName = fieldVal(form, 'carrierName');
      shipping.carrierAddress = fieldVal(form, 'carrierAddress');
      shipping.carrierPhone = fieldVal(form, 'carrierPhone');
      shipping.customerCode = fieldVal(form, 'customerCode');
      if (!shipping.carrierName) missing.push('carrierName');
      if (!shipping.carrierAddress) missing.push('carrierAddress');
    }
    var buyer = { notes: fieldVal(form, 'notes') };
    if (form.querySelector('[name="addressId"]')) buyer.addressId = fieldVal(form, 'addressId');
    else {
      buyer.addressLine = fieldVal(form, 'addressLine');
      buyer.city = fieldVal(form, 'city');
      buyer.country = fieldVal(form, 'country');
      if (!buyer.addressLine) missing.push('addressLine');
    }
    if (missing.length) {
      missing.forEach(function (n) { var el = form.querySelector('[name="' + n + '"]'); if (el) el.classList.add('is-missing'); });
      errEl.textContent = t('required');
      errEl.hidden = false;
      return;
    }

    btn.disabled = true;
    btn.textContent = t('working');
    api('/checkout', {
      method: 'POST',
      body: {
        paymentMethod: paymentMethod,
        shipping: shipping,
        buyer: buyer,
        expectedTotalUSD: view.cart.totalUSD
      }
    }).then(function (res) {
      if (!res.ok) {
        if (res.data.cart) { view.cart = res.data.cart; view.error = errText(res.data); render(); return; }
        btn.disabled = false;
        btn.textContent = paymentMethod === 'bank_transfer' ? t('placeOrder') : t('toPayment');
        errEl.textContent = errText(res.data);
        errEl.hidden = false;
        return;
      }
      if (res.data.paymentPageUrl) {
        btn.textContent = t('redirecting');
        window.location.href = res.data.paymentPageUrl;
        return;
      }
      setCount(0);
      view.cart = null;
      renderBankResult(res.data);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = paymentMethod === 'bank_transfer' ? t('placeOrder') : t('toPayment');
      errEl.textContent = t('netErr');
      errEl.hidden = false;
    });
  }

  // Havale talimatlari: her tedarikci icin banka + tutar + referans + "Havaleyi yaptim"
  function transferBlocks(checkout) {
    return checkout.suppliers.map(function (s) {
      var pendingOrders = checkout.orders.filter(function (o) { return o.supplierId === s.supplierId && o.status === 'pending_payment'; });
      var b = s.bankTransfer || {};
      var action = s.transferDeclaredAt
        ? '<div class="rnw-cart-declared">' + esc(t('declared')) + '</div>'
        : pendingOrders.length
          ? '<button type="button" class="rnw-acc-btn rnw-acc-btn--primary rnw-acc-btn--sm" data-declare="' + esc(s.supplierId) + '" data-checkout="' + esc(checkout.checkoutId) + '" data-name="' + esc(s.name) + '">' + esc(t('declare')) + '</button>'
          : '';
      return '<div class="rnw-cart-transfer">' +
        '<div class="rnw-cart-transfer__head"><strong>' + esc(s.name) + '</strong><span>' + tl(s.totalTRY) + ' <small>(' + usd(s.totalUSD) + ')</small></span></div>' +
        '<dl>' +
          (b.bankName ? '<dt>' + esc(t('bank')) + '</dt><dd>' + esc(b.bankName) + (b.branch ? ' / ' + esc(b.branch) : '') + '</dd>' : '') +
          (b.accountHolder ? '<dt>' + esc(t('holder')) + '</dt><dd>' + esc(b.accountHolder) + '</dd>' : '') +
          '<dt>IBAN</dt><dd class="rnw-cart-iban"><span>' + esc(b.iban || '—') + '</span>' +
            (b.iban ? '<button type="button" class="rnw-cart-copy" data-copy="' + esc(b.iban) + '">' + esc(t('copy')) + '</button>' : '') + '</dd>' +
          '<dt>' + esc(t('amount')) + '</dt><dd><strong>' + tl(s.totalTRY) + '</strong></dd>' +
          '<dt>' + esc(t('reference')) + '</dt><dd class="rnw-cart-iban"><strong>' + esc(s.reference) + '</strong>' +
            '<button type="button" class="rnw-cart-copy" data-copy="' + esc(s.reference) + '">' + esc(t('copy')) + '</button></dd>' +
          '<dt>' + esc(t('orders')) + '</dt><dd>' + esc(s.orderNumbers.join(', ')) + '</dd>' +
        '</dl>' +
        action +
      '</div>';
    }).join('');
  }

  function bindTransferActions(container, onDone) {
    container.querySelectorAll('[data-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-copy');
        var done = function () { btn.textContent = t('copied'); setTimeout(function () { btn.textContent = t('copy'); }, 1500); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(done, function () {});
      });
    });
    container.querySelectorAll('[data-declare]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!window.confirm(t('declareConfirm', { name: btn.getAttribute('data-name') }))) return;
        btn.disabled = true;
        api('/checkouts/' + btn.getAttribute('data-checkout') + '/transfer-declared', {
          method: 'POST', body: { supplierId: btn.getAttribute('data-declare') }
        }).then(function (res) {
          if (res.ok) onDone(res.data);
          else { btn.disabled = false; toast(errText(res.data), false, true); }
        });
      });
    });
  }

  function renderBankResult(checkout) {
    var root = view.root;
    root.innerHTML = head() +
      '<div class="rnw-cart-done">' +
        '<div class="rnw-cart-done__title">✓ ' + esc(t('bankDoneTitle')) + ' <span class="rnw-acc-order-no">' + esc(checkout.checkoutNumber) + '</span></div>' +
        '<p>' + esc(t('bankDoneSub')) + '</p>' +
        '<div class="rnw-cart-transfers">' + transferBlocks(checkout) + '</div>' +
        '<a class="rnw-acc-btn rnw-acc-btn--sm" href="' + ACCOUNT_URL + '#orders">' + esc(t('goOrders')) + '</a>' +
      '</div>';
    bindTransferActions(root, renderBankResult);
  }

  // Siparisler sekmesinin ustu: odeme donus mesaji + bekleyen havaleler
  var returnShown = false;
  function mountPending(el) {
    if (!el) return;
    var banner = '';
    if (!returnShown) {
      var params = new URLSearchParams(window.location.search);
      var p = params.get('payment');
      if (p) {
        returnShown = true;
        banner = '<div class="rnw-cart-note' + (p === 'paid' ? ' is-ok' : ' is-error') + '">' + esc(p === 'paid' ? t('paidBanner') : t('failedBanner')) + '</div>';
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname + window.location.hash);
        }
        refreshBadge();
      }
    }
    el.innerHTML = banner;
    if (!token()) return;
    api('/checkouts?status=awaiting_transfer').then(function (res) {
      if (!res.ok || !res.data.checkouts || !res.data.checkouts.length) return;
      el.innerHTML = banner + '<div class="rnw-cart-pending">' +
        '<div class="rnw-cart-pending__title">' + esc(t('pendingTitle')) + '</div>' +
        '<p class="rnw-cart-small">' + esc(t('pendingSub')) + '</p>' +
        res.data.checkouts.map(function (c) {
          return '<div class="rnw-cart-pending__checkout"><span class="rnw-acc-order-no">' + esc(c.checkoutNumber) + '</span>' +
            '<div class="rnw-cart-transfers">' + transferBlocks(c) + '</div></div>';
        }).join('') +
      '</div>';
      bindTransferActions(el, function () { mountPending(el); });
    });
  }

  window.rnwCart = { add: add, refreshBadge: refreshBadge, mount: mount, mountPending: mountPending, t: t };

  document.addEventListener('DOMContentLoaded', function () {
    ensureFab();
    refreshBadge();
  });
})();
